export default __webpack_public_path__ + "static/media/1233.ef031f7c.png";